import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import AboutUs from "@/pages/AboutUs";

export const Route = createFileRoute("/about-us")({
  head: () => routeHead('About AGAPE — Our Team and Approach', META_DESCRIPTIONS.about.en, '/about-us'),
  component: AboutUs,
});
